export default __webpack_public_path__ + "static/media/0xe13521b74b9bdb3b9d476a8ea5d871cb742c1615.03235c32.png";